export default __webpack_public_path__ + "static/media/coresanscr15it-webfont.f506cb22.woff";